export const defaultEntity = "prestiti";
export const entities = ["prestiti"];
export const labels = {
  prestiti: "Prestiti",
};
